<h3 class="headline">Why do I have to verify?</h3>
<p class="mb-6">We have reviewed your account and require you to verify your profile.</p>
<p class="mb-6">
  Your account will have limited functionality until you submit a verification request and it becomes approved.
</p>
<a
  class="width-100"
  sbButton
  [routerLink]="['/next/me/verifications']"
  [size]="'big'"
  [stretchable]="true"
  [variant]="'fill-verified'"
  (click)="confirm()"
  >Get Verified</a
>
